@if (filterForm) {
  <div class="link-workday-project-container">
    <div class="workday-header">
      <h3>Link Workday Project(s) to Hub Record {{project.projectId}}</h3>
    </div>
    <div class="filter-panel">
      <div class="filters" [formGroup]="filterForm">
        <mat-form-field>
          <mat-label>Date Range</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="dateRangeFilter" panelClass="hub-select-panel">
            @for (dateRange of dateRanges; track dateRange) {
              <mat-option [value]="dateRange">{{dateRange.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- <mat-form-field>
        <mat-label>Business Unit</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="buFilters" multiple >
          <mat-option *ngFor="let bu of businessUnits" [value]="bu">{{bu.name}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <!-- <mat-form-field class="freetext-filter">
    </mat-form-field> -->
    <div class="freetext-filter-panel">
      <input class="freetext-filter" placeholder="Search by Workday Project ID or Name" formControlName="workdayNameFilter">
    </div>
  </div>
  <div class="reset-panel">
    <a href="javascript: void(0)" (click)="resetFilters()">
      Clear Filters
    </a>
  </div>
</div>
@if (searchResult?.results.length) {
  <div class="results-panel" matSort matSortActive="createdOn" matSortDirection="desc"
    (matSortChange)="sortData($event)">
    <div class="results-header">
      <div>Link WD Project</div>
      <div mat-sort-header="workdayProjectId">WD Project ID</div>
      <div mat-sort-header="startDate">WD Start Date</div>
      <div mat-sort-header="status">WD Status</div>
      <div mat-sort-header="workdayProjectName">WD Project Name</div>
      <!-- <div mat-sort-header="businessUnit">Business Unit</div> -->
    </div>
    <div class="results-grid">
      @for (financeProject of searchResult?.results; track financeProject) {
        <div class="result-row" [ngClass]="{'linked': isLinked(financeProject)}"
          >
          <div>
            @if(isLinked(financeProject)) {
              @if(isLinkedToThisProject(financeProject)) {
                <div style="color: #49a942; font-weight: 500;">
                  Linked
                  <img src="assets/images/checkmark.png" style="width: 20px; margin-left: 5px">
                </div>
              }
              @else {
              <a href="/portfolio/{{financeProject.linkedProjectId}}" target="_blank">
                Linked to Hub Record {{financeProject.linkedProjectId}}
              </a>
            }
          }
          @else {
          <!-- <div style="padding: 5px; border: 1px solid red;">hola</div> -->
          <button (click)="addLink(financeProject)">
            <div>Link</div>
            <img src="assets/images/icons/link_icon_white.png">
          </button>
        }
      </div>
      <div>{{financeProject.workdayCode}}</div>
      <div class="date">{{financeProject.startDate | date:'dd-MMM-yyyy'}}</div>
      <div>{{financeProject.status}}</div>
      <div>{{financeProject.name}}</div>
      <!-- <div>{{financeProject.businessUnitName ? financeProject.businessUnitName : '(No BU in Workday)'}}</div> -->
    </div>
  }
</div>
</div>
}
@if (searchResult?.results.length === 0) {
  <div class="no-results-panel">
    <div class="alert alert-info alert-styled-left">
      No Matching Workday Projects Found
    </div>
  </div>
}
<div class="pager-panel">
  @if (searchResult?.results.length) {
    <app-hub-paginator [currentPage]="searchResult.page"
      [totalItems]="searchResult.filteredItemsCount" [totalPages]="searchResult.filteredPagesCount"
      (pageRequested)="pageRequested($event)">
    </app-hub-paginator>
  }
</div>
<div class="finance-projects-footer">
  <button (click)="close()">
    <div>Done</div>
  </button>
</div>
</div>
}
